import { render, staticRenderFns } from "./WebsiteDescriptions.vue?vue&type=template&id=7eb79664&scoped=true&"
import script from "./WebsiteDescriptions.vue?vue&type=script&lang=js&"
export * from "./WebsiteDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteDescriptions.vue?vue&type=style&index=0&id=7eb79664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb79664",
  null
  
)

export default component.exports